import type { ProductFilteredLabels } from "src/hooks/useFilterProductLabels";
import type { CatalogProduct } from "src/types/graphql.d";

export function generateProductCardProps(
  product: CatalogProduct,
  labels: ProductFilteredLabels
): CatalogProduct {
  return {
    ...product,
    labels: labels[product.slug]?.flatMap((item) => (item ? item : [])),
  };
}
